<template>
  <Modal
    v-model="_value"
    width="400"
    title="维修订单追加备注"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">
    <Form ref="renewalOrderForm" :model="maintainOrder" :label-width="80">
      <FormItem prop="content" label="备注">
        <Input style="width: 100%;" v-model="maintainOrder.content"
               type="textarea"
               placeholder="请输入备注"></Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'maintainorderaddtoremarkmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      maintainOrder: {
        id: null,
        content: null
      }
    }
  },
  methods: {
    ...mapActions([
      'MaintainOrderServ_AddToRemark'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认追加备注</p>',
        onOk: () => {
          store.dispatch('MaintainOrderServ_AddToRemark',
            { params: this.maintainOrder }).then(() => {
            this.$Message.success('确认成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.maintainOrder.id = this._initValue
        this.maintainOrder.content = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
